export default __webpack_public_path__ + "c5b90a21f9fa959af685811c37383e2f.svg";